<template>
  <div class="playerDetail_inforPanel" v-if="playerBaseInfor">
    <div
      class="player_image"
      :class="playerBaseInfor.playerLogo ? 'isLogo' : ''"
    >
      <img
        v-if="playerBaseInfor.playerLogo"
        :src="playerBaseInfor.playerLogo"
      />
    </div>
    <div class="player_baseInfor">
      <div
        class="player_name"
        v-text="_valPerFormatHandler(playerBaseInfor.playerName)"
      ></div>
      <div class="team_infor">
        <span class="delegationItem">
          <span class="delegationLogo">
            <img :src="playerBaseInfor.delegationLogo" />
          </span>
          <span
            class="delegationId"
            v-text="playerBaseInfor.delegationId"
          ></span>
        </span>
        <span
          class="delegationName"
          v-text="_valPerFormatHandler(playerBaseInfor.delegationName)"
        ></span>
      </div>
      <div class="infor_other">
        <span
          class="infor_other_item"
          v-text="_valPerFormatHandler(playerBaseInfor.height, 'CM')"
        ></span>
        <span
          class="infor_other_item"
          v-text="_valPerFormatHandler(playerBaseInfor.weight, 'KG')"
        ></span>
        <span
          class="infor_other_item"
          v-text="_valPerFormatHandler(playerBaseInfor.birthDate)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'playerDetail_inforPanel',
  mixins: [cup_base_data_mixin],
  props: {
    playerBaseInfor: {
      type: Object,
      default: () => {
        return {
          playerId: '',
          playerName: '',
          playerLogo: null,
          gender: '',
          birthDate: null,
          height: '',
          weight: '',
          delegationId: '',
          delegationName: '',
          delegationLogo: null,
          medalTotal: 0,
          medalGold: 0,
          medalSilver: 0,
          medalBronze: 0,
        }
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.playerDetail_inforPanel {
  /* height: 12.36vw;
  width: 100%;
  padding-top: 3.125vw; */
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .player_image {
    width: 12.222vw;
    height: 15.625vw;
    border: 0.694vw solid var(--mixtmt_mainColor4);
    background-image: var(--mixtmt_default_playerLogo);
    background-repeat: no-repeat;
    background-size: 110% auto;
    background-position: center;
    overflow: hidden;
    &.isLogo {
      background-image: none;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .player_baseInfor {
    padding: 0 1.388vw;
    width: calc(100% - 12.222vw);
    .player_name {
      padding-top: 1.736vw;
      font-size: 2.083vw;
      width: 100%;
      font-weight: bold;
      color: var(--mixtmt_whiteColor);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .team_infor {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      padding-top: 1.736vw;
      width: 100%;
      height: auto;
      .delegationItem {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: auto;
        height: 2.083vw;
        background-color: var(--mixtmt_greyColor9);
        color: var(--mixtmt_whiteColor);
        padding: 0.138vw;
        .delegationLogo {
          width: 2.71vw;
          height: 1.807vw;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .delegationId {
          width: calc(100% - 2.71vw);
          padding-left: 0.416vw;
          font-size: 0.903vw;
          text-align: center;
        }
      }
      .delegationName {
        padding: 0 0.694vw;
        width: calc(100% - 2.5vw);
        font-size: 1.25vw;
        color: var(--mixtmt_whiteColor);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .infor_other {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      padding-top: 1.736vw;
      width: 100%;
      height: auto;
      .infor_other_item {
        position: relative;
        font-size: 1.11vw;
        color: var(--mixtmt_whiteColor);
        padding: 0 0.694vw;
        &:first-child {
          padding: 0 0.694vw 0 0;
        }
        &::before {
          content: '\20';
          position: absolute;
          top: 0;
          right: 0;
          z-index: 2;
          width: 1px;
          height: 100%;
          background-color: var(--mixtmt_whiteColor);
        }
        &:last-child {
          &::before {
            visibility: hidden;
          }
        }
      }
    }
  }
}

.mixtmt_pc .playerDetail_inforPanel {
  .detailInfor_left {
    cursor: pointer;
  }
}
</style>
